<script lang="ts" setup>
import { useRecordingUtils } from 'core'

definePageMeta({
  path: '/listen/:id',
  layout: false
})

const route = useRoute()
const result = await useRecordingData(route.params.id, { trackEvent: true })

const data = result.data.value
const disableBranding = isCustomDomain(data?.user.domain)

if (!data) {
  useSeoMeta({
    title: 'Page not found'
  })
}

else {
  const { audio, settings, user } = data
  const utils = useRecordingUtils({ ...audio, domain: user.domain })

  const title = `Recording by ${settings.name || 'Someone'}`
  const description = utils.getTitle({ maxLength: 200 })
  const ogImage = audio.imageUrl

  useSeoMeta({
    title,
    description,
    titleTemplate: disableBranding ? '%s' : undefined,

    ogTitle: title,
    ogDescription: description,
    ogAudioUrl: audio.audioUrl,
    ogImage,
    ogImageWidth: '350',
    ogUrl: utils.getLink(),
    ogType: 'website',

    twitterTitle: title,
    twitterDescription: description,
    twitterImage: ogImage,
    twitterCard: 'summary_large_image'

    // TODO: add twitter card when embed player is ready
  })
}
</script>

<template>
  <PageListen :data :disable-branding />
</template>
